export default class Bar {
    constructor(Component) {
        this.items      = [];
        this.Component  = Component;
    }
    get container() {
        return this.Component.container.querySelector('.box-bar');
    }
    belongsToBar(type) {
        return type.split('-').indexOf('bar') !== -1;
    }
    add(type) {
        this.items.push(type);
    }
    render() {
        if (this.items.length || this.Component.container.dataset.quickBuy) { // only replace server rendered items if there are dynamic items
            let content = [];
            this.items.forEach(type => content.push(this.Component.Layout.getButton(type)));
            if (this.container)
                this.container.innerHTML = content.join('');
        }
    }
}
